import { Link } from 'react-router-dom';
import './slide3.scss';

export const Slide3 = () => {
    return (
        <div className='container-slide slide3'>

            <div className='div-pai-slides'>

                <h1 className='bracket-title'> Para você </h1>
                <p className='slide-subtitle'>
                    Programe sua viagem com a Cobalt e fique tranquilo.
                </p>
                <p className='slide-text'>
                    Não é só uma operação de câmbio: Oferecemos o que os outros
                    oferecem, mas com eficiência, agilidade e personalização. Possuímos
                    uma plataforma conectada à múltiplos players, possibilitando que
                    você consiga as melhores condições e taxas do mercado para enviar
                    ou receber uma remessa.
                </p>

                <Link to={"/cadastro"} className='slide-button' style={{marginTop:"10px"}}> Abra sua conta agora </Link>

            </div>

        </div >

    )
}
